/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{display:flex}button[_ngcontent-%COMP%]{flex-grow:0;margin-right:5px}nz-alert[_ngcontent-%COMP%]{flex-grow:1}[_nghost-%COMP%]     .ant-alert{text-align:center}"];
export { styles as styles };
